<template>
    <div class="xshzDetail">
        <div class="Contain" >
            <div class='xshzCon' :style="{
                minHeight: `calc(100vh - ${topHeight}px )`,
            }">
                <img class='hztitle' src="../../assets/images/hztitle.jpg" alt="">
                <div class='hzboll'>
                    <div class='boll'>
                        <img @click='handleclickzg(njsbg._id,njsbg.qyCount)' class='njsb' src="../../assets/images/njsb.png" alt="">
                        <img @click='handleclickzg(spjgg._id,spjgg.qyCount)' class='spjg' src="../../assets/images/spjg.png" alt="">
                        <img @click='handleclickzg(qyppg._id,qyppg.qyCount)' class='qypp' src="../../assets/images/qypp.png" alt="">
                        <img @click='handleclickzg(xczxg._id,xczxg.qyCount)' class='xczx' src="../../assets/images/xczx.png" alt="">
                        <img @click='handleclickzg(zhnzg._id,zhnzg.qyCount)' class='zhny' src="../../assets/images/zhny.png" alt="">
                        <img @click='handleclickzg(nhzpg._id,nhzpg.qyCount)' class='nhzp' src="../../assets/images/nhzp1.png" alt="">
                    </div>
                </div>
            </div>

            <div class="containBottom1">
                <div class='containBottomCon'>
                    <div>云览名企 VR探场 优企联动</div>
                    <div>即刻入馆 抢抓商机 18910514060</div>
                </div>
            </div>

        </div>

    </div>

</template>
<script setup>
import { ref, getCurrentInstance, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const props = defineProps({
    topHeight: {
        type: Number,
        default: 0
    }
})

const zhnzg = ref({})
const nhzpg = ref({})
const njsbg = ref({})
const spjgg = ref({})
const qyppg = ref({})
const xczxg = ref({})



// 计算 100vh - topHeight 的值
const vhMinusTopHeight = computed(() => {
    return windowHeight.value - topHeight.value;
});

// 计算 1080 - topHeight 的值
const fixedMinusTopHeight = computed(() => {
    return 1080 - topHeight.value;
});

// 判断使用哪个值
const useFixedValue = computed(() => {
    return vhMinusTopHeight.value < fixedMinusTopHeight.value;
});

// 优化后的最小高度计算
const computedMinHeight = computed(() => {
    if (vhMinusTopHeight.value < fixedMinusTopHeight.value) {
        return `${fixedMinusTopHeight.value}px`;
    } else {
        return `calc(100vh - ${topHeight.value}px)`;
    }
});




const getListInfo = () => {
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_SXYZGLIST",
        data: {

        },
    }).then((res) => {
        if (res.data.code == "000") {
            res.data.result.map((item) => {
                if (item.zgmc == '智慧农业馆' || item.zgmc == '农业生产厅' ) {
                    zhnzg.value = item
                }
                if (item.zgmc == '农化制品馆' || item.zgmc == '农机制造厅') {
                    nhzpg.value = item
                }
                if (item.zgmc == '农机设备馆' || item.zgmc == '农资产品厅') {
                    njsbg.value = item
                }
                if (item.zgmc == '食品加工馆' || item.zgmc == '食品加工厅') {
                    spjgg.value = item
                }
                if (item.zgmc == '区域品牌馆' ||item.zgmc == '农业服务厅') {
                    qyppg.value = item
                }
                if (item.zgmc == '乡村振兴馆' || item.zgmc == '农业科技厅') {
                    xczxg.value = item
                }

                
            })
        }
    });
}
getListInfo()

const handleclickzg = (id,count) => {
    var numberCount = Number(count)
    console.log(numberCount)
    if(numberCount>0){
        router.push({
            path: '/xshzDetails',
            query: {
                id: id
            }
        });
    }
    
}


</script>
<style lang="less" scoped>

// @media (max-width: 500px) {
//     .hzboll {
//     margin-top: 195px;
//     margin-right: 20px;
//     position: relative;}
// }

.xshzDetail {
    width: 100%;
    min-width: 1240px;

    .Contain {
        box-sizing: content-box;
        min-width: 1240px;
        width: 100%;
        background: url('../../assets/images/hzbj.png') no-repeat;
        background-size: 100% 100%;
        position: relative;

        .xshzCon {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;

            .hztitle {
                width: 380px;
                height: 208px;
                margin-top: 185px;
            }

            .hzboll {
                margin-top: 155px;
                margin-right: 20px;
                position: relative;

                .boll {
                    width: 786px;
                    height: 630px;
                    background: url('../../assets/images/hzboll.jpg') no-repeat;
                    background-size: 100% 100%;
                    position: relative;

                    .njsb {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: -51px;
                        left: 362px;
                    }

                    .njsb:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: -51px;
                        left: 352px;
                    }

                    .spjg {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: 3px;
                        left: 83px;

                    }

                    .spjg:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: 3px;
                        left: 73px;
                    }

                    .qypp {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: 288px;
                        left: 47px;
                    }

                    .qypp:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: 288px;
                        left: 37px;
                    }

                    .xczx {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: 384px;
                        left: 338px;
                    }

                    .xczx:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: 384px;
                        left: 328px;
                    }

                    .zhny {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: 285px;
                        right: 22px;
                    }

                    .zhny:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: 285px;
                        right: 12px;
                    }

                    .nhzp {
                        width: 113px;
                        height: 108px;
                        position: absolute;
                        top: 32px;
                        right: 49px;
                    }

                    .nhzp:hover {
                        width: 133px;
                        height: 118px;
                        position: absolute;
                        top: 32px;
                        right: 39px;
                    }
                }


            }
        }

        .containBottom1 {
            width: 100%;
            height: 25vh;
            background: url('../../assets/images/hzbottom.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            bottom: -2px;
            left: 0;
            z-index: 1;
            display: flex;
            align-items: end;
            padding-bottom: 20px;


            .containBottomCon {
                width: 1200px;
                height: 45px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                font-size: 26px;
                color: #FFFFFF;
                font-weight: 900;
                align-items: center;
                margin-top: -30px;
                padding: 0 30px;
            }
        }
    }
}

@media (min-width: 1200px) {

}
@media (min-width: 1680px) {
    .xshzDetail {
        .Contain {
            box-sizing: content-box;
            min-width: 1600px;
            width: 100%;
            background: url('../../assets/images/hzbj.png') no-repeat;
            background-size: 100% 100%;
            position: relative;

            .xshzCon {
                width: 1600px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;

                .hztitle {
                    width: 524px;
                    height: 278px;
                    margin-top: 82px;
                }

                .hzboll {

                    margin-top: 95px;
                    margin-right: 20px;
                    position: relative;

                    .boll {
                        width: 939px;
                        height: 675px;
                        background: url('../../assets/images/hzboll.jpg') no-repeat;
                        background-size: 100% 100%;
                        position: relative;

                        .njsb {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: -100px;
                            left: 431px;
                        }

                        .njsb:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: -100px;
                            left: 421px;
                        }

                        .spjg {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: -16px;
                            left: 85px;
                        }

                        .spjg:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: -16px;
                            left: 75px;
                        }

                        .qypp {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: 290px;
                            left: 52px;
                        }

                        .qypp:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: 290px;
                            left: 42px;
                        }

                        .xczx {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: 380px;
                            left: 383px;
                        }

                        .xczx:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: 380px;
                            left: 373px;
                        }

                        .zhny {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: 293px;
                            right: 25px;
                        }

                        .zhny:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: 293px;
                            right: 15px;
                        }


                        .nhzp {
                            width: 153px;
                            height: 138px;
                            position: absolute;
                            top: 17px;
                            right: 30px;

                        }

                        .nhzp:hover {
                            width: 186px;
                            height: 148px;
                            position: absolute;
                            top: 17px;
                            right: 20px;
                        }
                    }


                }
            }

            .containBottom1 {
                width: 100%;
                height: 25vh;
                background: url('../../assets/images/hzbottom.png') no-repeat;
                background-size: 100% 100%;
                position: absolute;
                bottom: -2px;
                left: 0;
                z-index: 1;
                display: flex;
                align-items: end;
                padding-bottom: 20px;

                .containBottomCon {
                    width: 1600px;
                    height: 45px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    font-size: 38px;
                    color: #FFFFFF;
                    font-weight: 900;
                    align-items: center;
                    padding: 0 30px;
                }
            }


        }

    }

}
</style>